import { cn } from '@/lib/shared/ui';
import Link from 'next/link';
import React from 'react';

export const HeaderLink = (
  props: React.AnchorHTMLAttributes<HTMLAnchorElement> & { label: string },
) => (
  <Link
    href={props.href || ''}
    {...props}
    className={cn('text-sm whitespace-nowrap', props.className)}
    data-testid={`${props.label.toLowerCase()}-link`}
  >
    {props.label}
  </Link>
);
